import { render } from "./CardLeisMunicipais.vue?vue&type=template&id=76a0ae7f"
import script from "./CardLeisMunicipais.vue?vue&type=script&lang=js"
export * from "./CardLeisMunicipais.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__